import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Nav from './nav/';

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.banner}>
                <Chip id="30006" type="struct" title="科技首页主导航" groupName="导航栏" content={content.nav}>
                    <Nav content={content.nav} />
                </Chip>
            </div>
        );
    }
}

export default Navigation;
